{
  "activity_start_time": "Hora de inicio de la actividad",
  "type": {
    "type_of_start_time": "Tipo de hora de inicio",
    "relative": "Relativo a la sesión/elemento programado",
    "relative_description": "Ejemplo: 2 minutos después del inicio de la sesión o 5 minutos después del último elemento programado",
    "fixed": "Corregido",
    "fixed_description": "Ejemplo: 09:00",
    "relative_time": "Hora relativa",
    "fixed_time": "Tiempo fijo"
  },
  "start_activity": "Iniciar la actividad",
  "preposition": {
    "before": "delante de",
    "after": "después"
  },
  "preposition_lables": {
    "before": "antes de que comience {{ type }}",
    "after": "después del inicio de {{ type }}"
  },
  "relative_to": {
    "start_time": "hora de inicio de",
    "end_time": "hora de finalización de",
    "zero_time": "hora cero de"
  },
  "relationship": {
    "every": "cada",
    "specific": "específico",
    "first": "primera",
    "last": "último"
  },
  "related_type": {
    "Session": "sesión",
    "Scheduled item": "elemento programado"
  },
  "repeat_activity": {
    "repeat_activity": "Repite la actividad",
    "repeat_on_all": "Repite los días (todos)",
    "none_selected": "No se ha seleccionado ninguno",
    "all_days": "Todos los días"
  },
  "info": {
    "can_not_delete": "No se puede eliminar este elemento del cronograma porque otro elemento del cronograma depende de él"
  }
}